<template>

    <div
        v-if="showImage" class="dmb-asset dmb-asset-image"
        v-background-image="!stuffed ? imageUrl : null"
        v-background-color="hexColor"
        :style="!stuffed ? {
            'background-position': 'center',
            'background-size': backgroundSize,
            'background-repeat': repeat ? 'repeat': 'no-repeat'
        } : null">
        <img v-if="stuffed" :src="imageUrl" />
    </div>

    <video
        v-else-if="showVideo" class="dmb-asset dmb-asset-video" ref="video"
        :autoplay="!freeze" :loop="repeat"
        v-background-color="hexColor"
        v-background-image="asset.thumbUrl"
        preload="metadata"
        :style="{
            'object-fit': backgroundSize,
            'background-position': 'center',
            'background-size': backgroundSize,
            'background-repeat': 'no-repeat'
        }"
        muted
    >
        <source :src="asset.url">
    </video>

    <div v-else class="dmb-asset" v-background-color="hexColor"></div>

</template>

<script>

import { Options, Vue } from 'vue-class-component';

import AssetContentMode from '../../enum/AssetContentMode';
import { getAssetContentModeCss } from '../../util/asset';
import ColorPreset from '../../enum/ColorPreset';
import AssetType from "../../enum/AssetType";

export default Options({

    name: 'dmb-asset',
    props: {
        contentMode: {
            type: String,
            default: AssetContentMode.COVER
        },
        repeat: {
            type: Boolean,
            default: true
        },
        color: {
            type: String,
            default: null
        },
        assetId: {
            type: String,
            default: null
        },
        freeze: {
            type: Boolean,
            default: false
        },
        stuffed: {
            type: Boolean,
            default: false
        }
    }
})(
    class Asset extends Vue {

    playVideo(){

        if(this.$refs.video){

            const video = this.$refs.video;

            video.pause();
            video.currentTime = 0;
            video.play();
        }
    }

    pauseVideo(){

        this.$refs.video?.pause();
    }

    get showImage(){
        return this.asset?.type === AssetType.IMAGE || (
                this.asset?.type === AssetType.VIDEO && this.freeze && this.asset.thumbUrl
            )
    }

    get showVideo(){
        return this.asset?.type === AssetType.VIDEO && this.asset.url && !this.freeze && this.asset.thumbUrl
    }

        get imageUrl(){

            return this.asset?.type === AssetType.VIDEO ? this.asset.thumbUrl : this.asset.url
        }

        get backgroundSize(){

            return getAssetContentModeCss(this.contentMode);
        }

        get asset(){

            return this.$store.getters.getAsset(this.assetId);
        }

        get hexColor(){

            const value = this.color;

            if(value && value.charAt(0) === '$'){

                const style = this.$store.state.style.showStyle;
                if(!style){
                    return null;
                }

                if(value === ColorPreset.PRIMARY){
                    return style.colorPrimary ? '#' + style.colorPrimary : null;
                }
                else if(value === ColorPreset.SECONDARY){
                    return style.colorSecondary ? '#' + style.colorSecondary : null;
                }
                else if (value === ColorPreset.TERTIARY){
                    return style.colorTertiary ? '#' + style.colorTertiary : null;
                }
            }

            if(value && value.charAt(0) !== '#'){
                return '#' + value
            }
            else {
                return value
            }
        }
    }
);

</script>

<style lang="scss" src="../../../scss/component/ui/Asset.scss"></style>